
// import { useState, useEffect } from "react";
// import axios from "axios";
// import Cookies from "js-cookie";
// import { X } from "lucide-react";
// import { createPortal } from "react-dom";

// export default function AssignItemModal({ isOpen, onClose }) {
//   const [inventoryItems, setInventoryItems] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [formData, setFormData] = useState({
//     inventory_id: "",
//     user_id: "",
//     additional_info: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     if (isOpen) document.body.style.overflow = "hidden";
//     else document.body.style.overflow = "auto";
//   }, [isOpen]);

//   const getInventoryItems = async () => {
//     const token = Cookies.get("token");
//     const res = await axios.get(
//       "/api/inventory/",
//       { headers: { Authorization: `Bearer ${token}` } }
//     );

//     if (res.data?.success) {
//       setInventoryItems(
//         res.data.data.filter((i) => i.status === "Idle")
//       );
//     }
//   };

//   const getUsers = async () => {
//     const token = Cookies.get("token");
//     const res = await axios.get(
//       "/api/users/",
//       { headers: { Authorization: `Bearer ${token}` } }
//     );

//     if (res.data?.success) setUsers(res.data.data);
//   };

//   useEffect(() => {
//     if (isOpen) {
//       getInventoryItems();
//       getUsers();
//     }
//   }, [isOpen]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((p) => ({ ...p, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     try {
//       const token = Cookies.get("token");

//       const res = await axios.post(
//         "/api/inventory/assign",
//         {
//           inventory_id: Number(formData.inventory_id),
//           user_id: Number(formData.user_id),
//           additional_info: formData.additional_info,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (res.data?.success) {
//         setFormData({
//           inventory_id: "",
//           user_id: "",
//           additional_info: "",
//         });
//         onClose();
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to assign item");
//     } finally {
//       setLoading(false);
//     }
//   };
// if (!isOpen) return null;

// return createPortal(
//   <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center">
//     <div className="
//       relative z-[10000]
//       w-full max-w-2xl
//       bg-white rounded-2xl
//       shadow-2xl text-gray-800
//     ">
//       {/* Header */}
//       <div className="flex justify-between items-center px-6 py-4 border-b">
//         <h2 className="font-semibold text-lg">
//           Assign Inventory Item
//         </h2>
//         <X
//           size={22}
//           onClick={onClose}
//           className="cursor-pointer text-gray-500 hover:text-red-600"
//         />
//       </div>

//       {/* Form */}
//       <form onSubmit={handleSubmit} className="p-6 space-y-5">
//         {error && (
//           <div className="bg-red-50 text-red-600 p-3 rounded text-sm">
//             {error}
//           </div>
//         )}

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           {/* Inventory */}
//           <div>
//             <label className="text-sm font-medium">
//               Inventory Item *
//             </label>
//             <select
//               name="inventory_id"
//               value={formData.inventory_id}
//               onChange={handleChange}
//               required
//               className="
//                 w-full mt-1 p-2.5
//                 border border-gray-300
//                 rounded-lg bg-white
//                 focus:ring-2 focus:ring-purple-500
//               "
//             >
//               <option value="">Select item</option>
//               {inventoryItems.map((i) => (
//                 <option key={i.id} value={i.id}>
//                   {i.item_id} - {i.name}
//                 </option>
//               ))}
//             </select>
//             <p className="text-xs text-gray-500 mt-1">
//               Only Idle items shown
//             </p>
//           </div>

//           {/* User */}
//           <div>
//             <label className="text-sm font-medium">
//               Assign To *
//             </label>
//             <select
//               name="user_id"
//               value={formData.user_id}
//               onChange={handleChange}
//               required
//               className="
//                 w-full mt-1 p-2.5
//                 border border-gray-300
//                 rounded-lg bg-white
//                 focus:ring-2 focus:ring-purple-500
//               "
//             >
//               <option value="">Select user</option>
//               {users.map((u) => (
//                 <option key={u.id} value={u.id}>
//                   {u.name} ({u.email})
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>

//         {/* Additional Info */}
//         <div>
//           <label className="text-sm font-medium">
//             Additional Info
//           </label>
//           <textarea
//             name="additional_info"
//             value={formData.additional_info}
//             onChange={handleChange}
//             rows={2}
//             className="
//               w-full mt-1 p-2.5
//               border border-gray-300
//               rounded-lg resize-none
//               focus:ring-2 focus:ring-purple-500
//             "
//           />
//         </div>

//         {/* Actions */}
//         <div className="flex justify-end gap-3 pt-3">
//           <button
//             type="button"
//             onClick={onClose}
//             className="
//               px-4 py-2 rounded-lg
//               bg-gray-200 hover:bg-gray-300
//             "
//           >
//             Cancel
//           </button>

//           <button
//             type="submit"
//             disabled={loading}
//             className="
//               px-6 py-2 rounded-lg
//               bg-purple-600 text-white
//               hover:bg-purple-700
//             "
//           >
//             {loading ? "Assigning..." : "Assign"}
//           </button>
//         </div>
//       </form>
//     </div>
//   </div>,
//   document.body
// );

// }



import { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { X } from "lucide-react";
import { createPortal } from "react-dom";
import { API_BASE_URL } from "../../../app/apiConfig";

export default function AssignItemModal({ isOpen, onClose }) {
  const [inventoryItems, setInventoryItems] = useState([]);
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({
    inventory_id: "",
    user_id: "",
    additional_info: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "auto";
  }, [isOpen]);

  const getInventoryItems = async () => {
    const token = Cookies.get("token");
    const res = await axios.get(
      `${API_BASE_URL}/inventory/`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.data?.success) {
      setInventoryItems(
        res.data.data.filter((i) => i.status === "Assignable")
      );
    }
  };

  const getUsers = async () => {
    const token = Cookies.get("token");
    const res = await axios.get(
      `${API_BASE_URL}/users/`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.data?.success) setUsers(res.data.data);
  };

  useEffect(() => {
    if (isOpen) {
      getInventoryItems();
      getUsers();
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const token = Cookies.get("token");
      const res = await axios.post(
        `${API_BASE_URL}/inventory/assign`,
        {
          inventory_id: Number(formData.inventory_id),
          user_id: Number(formData.user_id),
          additional_info: formData.additional_info,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (res.data?.success) {
        setFormData({
          inventory_id: "",
          user_id: "",
          additional_info: "",
        });
        onClose();
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to assign item");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
      <div className="
        relative z-[10000]
        w-full max-w-2xl rounded-2xl
        bg-white/15 backdrop-blur-xl
        shadow-2xl border border-white/20
        text-white
      ">

        {/* Header */}
        <div className="
          flex justify-between items-center px-6 py-4
          rounded-t-2xl
          bg-gradient-to-r from-[#2d1c6a] to-[#24155a]
        ">
          <h2 className="font-semibold text-lg">
            Assign Inventory Item
          </h2>
          <X
            size={22}
            onClick={onClose}
            className="cursor-pointer text-white/80 hover:text-red-300"
          />
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-5">

          {error && (
            <div className="bg-red-500/20 text-red-300 p-3 rounded text-sm">
              {error}
            </div>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Inventory */}
            <div>
              <label className="text-sm text-white/80">
                Inventory Item *
              </label>
              <select
                name="inventory_id"
                value={formData.inventory_id}
                onChange={handleChange}
                required
                className="
                  w-full mt-1 p-2.5
                  bg-white/10 border border-white/20
                  rounded-lg 
                  focus:ring-2 focus:ring-purple-400
                "
              >
                <option value=" " className="text-black bg-white">Select item</option>
                {inventoryItems.map((i) => (
                  <option key={i.id} value={i.id} className="text-black bg-white">
                    {i.item_id} - {i.name}
                  </option>
                ))}
              </select>
              <p className="text-xs text-white/50 mt-1">
                Only Assignable items shown
              </p>
            </div>

            {/* User */}
            <div>
              <label className="text-sm text-white/80">
                Assign To *
              </label>
              <select
                name="user_id"
                value={formData.user_id}
                onChange={handleChange}
                required
                className="
                  w-full mt-1 p-2.5
            bg-white text-gray-800 border border-white/20

                  rounded-lg
                  focus:ring-2 focus:ring-purple-400
                "
              >
                <option value="" className="text-black bg-white">Select user</option>
                {users.map((u) => (
                  <option key={u.id} value={u.id} className="text-black bg-white">
                    {u.name} ({u.email})
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Additional Info */}
          <div>
            <label className="text-sm text-white/80">
              Additional Info
            </label>
            <textarea
              name="additional_info"
              value={formData.additional_info}
              onChange={handleChange}
              rows={2}
              className="
                w-full mt-1 p-2.5
                bg-white/10 border border-white/20
                rounded-lg resize-none
                focus:ring-2 focus:ring-purple-400
              "
            />
          </div>

          {/* Actions */}
          <div className="flex justify-end gap-3 pt-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded bg-white/10 hover:bg-white/20"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
              className="px-6 py-2 rounded bg-purple-600 hover:bg-purple-500"
            >
              {loading ? "Assigning..." : "Assign"}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}
